import React, { useContext } from "react";
import AboutUsContent from "../../static-data/AboutUsContent.json";
import LangContext from "../../../context/LangContext";
const AboutSection = () => {
  const { lang_code } = useContext(LangContext);
  return (
    <div>
      <h1 className="font-bold text-3xl my-5 text-primary-base">ABOUT US</h1>
      {lang_code === "en" ? (
        <div className="prose max-w-full prose-p:text-justify xl:prose-lg prose-p:leading-loose my-8">
          <h1>Welcome to Himalayan Ultimate Trekking Nepal!</h1>
          <p>
            At <strong>Himalayan Ultimate Trekking Nepal</strong>, we are
            passionate about exploring the breathtaking landscapes of Nepal and
            offering our clients unforgettable trekking experiences. Our company
            is located in the enchanting town of Suryabinayak, Bhaktapur, a
            place that holds a deep cultural and historical significance.
            Nestled amidst the majestic Himalayas, our prime location allows us
            to embark on thrilling adventures into the Langtang, Everest, and
            Annapurna regions, among others.
          </p>
          <h2>Our Journey</h2>
          <p>
            Our journey began with a vision to share the awe-inspiring beauty of
            Nepal with adventurers from all corners of the world. Since our
            inception, we have organized numerous successful trekking
            expeditions, creating memories that last a lifetime for our valued
            explorers. With each step we take, we strive to maintain a perfect
            balance between preserving the pristine beauty of the Himalayas and
            providing exceptional trekking experiences.
          </p>
          <h2>Local Expertise</h2>
          <p>
            What sets Himalayan Ultimate Trekking Nepal apart is our in-depth
            local knowledge. Our experienced guides and support staff are
            well-versed in the hidden gems of the region, ensuring you get an
            authentic and immersive experience. From traditional villages to
            remote trails, we take you beyond the beaten path, allowing you to
            soak in the rich culture, warm hospitality, and breathtaking vistas
            that Nepal has to offer.
          </p>
          <h2>Trekking Expeditions</h2>
          <p>
            We specialize in trekking expeditions to some of the most iconic
            destinations in Nepal. Whether you dream of standing beneath the
            towering peaks of Everest Base Camp, traversing the mystical
            landscapes of Langtang Valley, or conquering the high passes of the
            Annapurna Circuit, we have the perfect trek for you. Each journey is
            carefully crafted to cater to different interests, fitness levels,
            and durations, ensuring there's something for everyone.
          </p>
          <h2>Small and Dedicated Teams</h2>
          <p>
            To ensure an intimate and personalized experience, we keep our
            trekking groups small. This allows us to focus on individual needs,
            safety, and sustainability. Our dedicated teams are not only skilled
            professionals but also passionate trekkers who love sharing their
            knowledge and stories with fellow adventurers.
          </p>
          <h2>Bonjour France!</h2>
          <p>
            While we welcome trekkers from all around the globe, we have
            developed a special connection with our friends from France. The
            stunning beauty of the Himalayas, coupled with the warmth of
            Nepalese hospitality, has drawn many French explorers to our
            doorstep. We take immense pride in being the go-to choice for French
            adventurers seeking a remarkable trekking experience in Nepal.
          </p>
          <h2>Our Commitment</h2>
          <p>
            At Himalayan Ultimate Trekking Nepal, safety is our utmost priority.
            We adhere to international trekking standards, and our guides are
            trained in first aid and rescue procedures. Additionally, we are
            committed to eco-friendly practices to ensure that the Himalayas
            remain pristine for generations to come.
          </p>
          <h2>Come and Trek with Us</h2>
          <p>
            Embark on a journey of a lifetime with Himalayan Ultimate Trekking
            Nepal. Whether you are an experienced trekker or a novice
            adventurer, our team will ensure that your trekking experience in
            Nepal is nothing short of extraordinary. Let us guide you through
            the enchanting trails, where every step leads to a new adventure and
            every moment becomes a cherished memory.
          </p>
          <p>
            Join us and be a part of our trekking family. Discover Nepal with
            Himalayan Ultimate Trekking Nepal - where every step is an
            adventure!
          </p>
        </div>
      ) : (
        <div className="prose max-w-full prose-p:text-justify xl:prose-lg prose-p:leading-loose my-8">
          <h1>Bienvenue chez Himalayan Ultimate Trekking Nepal !</h1>
          <p>
            Chez <strong>Himalayan Ultimate Trekking Nepal</strong>, nous sommes
            passionnés par l'exploration des paysages époustouflants du Népal et
            nous offrons à nos clients des expériences de trekking inoubliables.
            Notre entreprise est située dans la charmante ville de Suryabinayak,
            Bhaktapur, un lieu d'une grande importance culturelle et historique.
            Niché au milieu des majestueuses Himalayas, notre emplacement
            privilégié nous permet de partir à l'aventure dans les régions du
            Langtang, de l'Everest et de l'Annapurna, entre autres.
          </p>
          <h2>Notre Histoire</h2>
          <p>
            Notre aventure a commencé avec la vision de partager la beauté
            époustouflante du Népal avec des aventuriers du monde entier. Depuis
            notre création, nous avons organisé de nombreuses expéditions de
            trekking réussies, créant des souvenirs qui resteront à jamais
            gravés pour nos précieux explorateurs. À chaque pas que nous
            faisons, nous nous efforçons de maintenir un équilibre parfait entre
            la préservation de la beauté immaculée de l'Himalaya et la
            fourniture d'expériences de trekking exceptionnelles.
          </p>
          <h2>Expertise Locale</h2>
          <p>
            Ce qui distingue Himalayan Ultimate Trekking Nepal, c'est notre
            connaissance approfondie de la région. Nos guides expérimentés et
            notre personnel de soutien connaissent bien les trésors cachés de la
            région, vous garantissant une expérience authentique et immersive.
            Des villages traditionnels aux sentiers isolés, nous vous emmenons
            hors des sentiers battus, vous permettant de vous imprégner de la
            riche culture, de l'hospitalité chaleureuse et des panoramas à
            couper le souffle que le Népal a à offrir.
          </p>
          <h2>Expéditions de Trekking</h2>
          <p>
            Nous sommes spécialisés dans les expéditions de trekking vers
            certaines des destinations les plus emblématiques du Népal. Que vous
            rêviez de vous tenir sous les sommets imposants du camp de base de
            l'Everest, de traverser les paysages mystiques de la vallée de
            Langtang ou de conquérir les hauts cols du circuit de l'Annapurna,
            nous avons le trek parfait pour vous. Chaque voyage est
            soigneusement conçu pour répondre à différents intérêts, niveaux de
            condition physique et durées, garantissant qu'il y en a pour tous
            les goûts.
          </p>
          <h2>Petites Équipes Dévouées</h2>
          <p>
            Afin de garantir une expérience intime et personnalisée, nous
            maintenons nos groupes de trekking restreints. Cela nous permet de
            nous concentrer sur les besoins individuels, la sécurité et la
            durabilité. Nos équipes dévouées sont non seulement des
            professionnels compétents, mais aussi des trekkeurs passionnés qui
            adorent partager leur savoir et leurs histoires avec leurs
            compagnons d'aventure.
          </p>
          <h2>Bonjour France !</h2>
          <p>
            Bien que nous accueillions des trekkeurs du monde entier, nous avons
            développé un lien spécial avec nos amis français. La beauté
            éblouissante de l'Himalaya, associée à la chaleur de l'hospitalité
            népalaise, a attiré de nombreux explorateurs français à notre porte.
            Nous sommes extrêmement fiers d'être le choix privilégié des
            aventuriers français en quête d'une expérience de trekking
            exceptionnelle au Népal.
          </p>
          <h2>Notre Engagement</h2>
          <p>
            Chez Himalayan Ultimate Trekking Nepal, la sécurité est notre
            priorité absolue. Nous respectons les normes internationales de
            trekking, et nos guides sont formés aux premiers soins et aux
            procédures de sauvetage. De plus, nous nous engageons à adopter des
            pratiques respectueuses de l'environnement afin que l'Himalaya reste
            préservé pour les générations futures.
          </p>
          <h2>Partez en Trek avec Nous</h2>
          <p>
            Embarquez pour une aventure inoubliable avec Himalayan Ultimate
            Trekking Nepal. Que vous soyez un trekkeur expérimenté ou un
            aventurier novice, notre équipe veillera à ce que votre expérience
            de trekking au Népal soit extraordinaire. Laissez-nous vous guider
            sur les sentiers enchanteurs, où chaque pas vous mènera vers une
            nouvelle aventure et chaque instant deviendra un souvenir précieux.
          </p>
          <p>
            Rejoignez-nous et devenez membre de notre famille de trekkeurs.
            Découvrez le Népal avec Himalayan Ultimate Trekking Nepal - où
            chaque pas est une aventure !
          </p>
        </div>
      )}
    </div>
  );
};

export default AboutSection;
